import React from "react";
const HangerBG = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      style={style}
      viewBox="0 0 36 36"
    >
      <g
        id="Raggruppa_1292"
        data-name="Raggruppa 1292"
        transform="translate(-834 -1395)"
      >
        <circle
          id="Ellisse_49"
          data-name="Ellisse 49"
          cx="18"
          cy="18"
          r="18"
          transform="translate(834 1395)"
          fill="#e0e0e0"
        />
        <g id="Hanger" transform="translate(838.261 1398.357)">
          <path
            id="Tracciato_336"
            data-name="Tracciato 336"
            d="M24.44,20.04,14.171,11.1V9.99A4.056,4.056,0,1,0,9.3,6.048a.811.811,0,1,0,1.622,0A2.433,2.433,0,1,1,13.36,8.482a.811.811,0,0,0-.811.811v1.841L2.28,20.056a.811.811,0,0,0,.535,1.4H23.9a.811.811,0,0,0,.535-1.419Zm-19.459-.2,8.379-7.3,8.379,7.3Z"
            transform="translate(0)"
            fill="#232323"
          />
        </g>
      </g>
    </svg>
  );
};
export default HangerBG;
